import { render, staticRenderFns } from "./TabBody.vue?vue&type=template&id=8976e028&scoped=true&"
import script from "./TabBody.vue?vue&type=script&lang=ts&"
export * from "./TabBody.vue?vue&type=script&lang=ts&"
import style0 from "./TabBody.vue?vue&type=style&index=0&id=8976e028&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8976e028",
  null
  
)

export default component.exports